import scalesIcon from '../../../../assets/landing-page-categories-icons/scales.svg';
import houseIcon from '../../../../assets/landing-page-categories-icons/house.svg';
import walletIcon from '../../../../assets/landing-page-categories-icons/wallet.svg';
import pawIcon from '../../../../assets/landing-page-categories-icons/paw.svg';
import globeIcon from '../../../../assets/landing-page-categories-icons/globe.svg';
import dumbbellIcon from '../../../../assets/landing-page-categories-icons/dumbbell.svg';
import suitcaseIcon from '../../../../assets/landing-page-categories-icons/suitcase.svg';
import laptopIcon from '../../../../assets/landing-page-categories-icons/laptop.svg';
import carIcon from '../../../../assets/landing-page-categories-icons/car.svg';
import buildingIcon from '../../../../assets/landing-page-categories-icons/building.svg';
import languagesIcon from '../../../../assets/landing-page-categories-icons/languages.svg';
import graduationCapIcon from '../../../../assets/landing-page-categories-icons/graduation-cap.svg';

/**
 * Stable display order for the homepage category directory (row-major grid).
 * Presentation only — does not alter taxonomy labels or subcategory data.
 */
export const CATEGORY_DISPLAY_ORDER = [
  'SvcCat_LEGL',
  'SvcCat_HOM',
  'SvcCat_TAX',
  'SvcCat_PETS',
  'SvcCat_REL',
  'SvcCat_BSH',
  'SvcCat_LSR',
  'SvcCat_BUS',
  'SvcCat_TRA',
  'SvcCat_REH',
  'SvcCat_TRN',
  'SvcCat_EDU',
];

/**
 * Decorative L1 icons keyed by stable category ID (asset URL from default SVG import).
 */
export const CATEGORY_ICON_BY_ID = {
  SvcCat_LEGL: scalesIcon,
  SvcCat_HOM: houseIcon,
  SvcCat_TAX: walletIcon,
  SvcCat_PETS: pawIcon,
  SvcCat_REL: globeIcon,
  SvcCat_BSH: dumbbellIcon,
  SvcCat_LSR: suitcaseIcon,
  SvcCat_BUS: laptopIcon,
  SvcCat_TRA: carIcon,
  SvcCat_REH: buildingIcon,
  SvcCat_TRN: languagesIcon,
  SvcCat_EDU: graduationCapIcon,
};

/**
 * Return a new array of category objects in the approved display order.
 * Known IDs follow CATEGORY_DISPLAY_ORDER; unknown IDs append in original
 * configuration order. Never mutates the input array or category objects.
 *
 * @param {Array<{ id: string }>} categories
 * @returns {Array<{ id: string }>}
 */
export const orderCategoriesForDisplay = categories => {
  if (!Array.isArray(categories) || categories.length === 0) {
    return [];
  }

  const orderIndexById = new Map(CATEGORY_DISPLAY_ORDER.map((id, index) => [id, index]));
  const known = [];
  const unknown = [];

  categories.forEach((category, originalIndex) => {
    const orderIndex = orderIndexById.get(category?.id);
    if (typeof orderIndex === 'number') {
      known.push({ category, orderIndex });
    } else {
      unknown.push({ category, originalIndex });
    }
  });

  known.sort((a, b) => a.orderIndex - b.orderIndex);

  return [...known.map(entry => entry.category), ...unknown.map(entry => entry.category)];
};

/**
 * Resolve the decorative icon URL for a stable category ID.
 * Returns null when the ID has no mapping (caller renders without an icon).
 *
 * @param {string} categoryId
 * @returns {string|null}
 */
export const getCategoryIconUrl = categoryId => {
  if (!categoryId) {
    return null;
  }
  return CATEGORY_ICON_BY_ID[categoryId] || null;
};
